export default "__VITE_ASSET__5a72d5c3__"